import React from 'react';
import { Link } from 'react-router-dom';
import './Navbar.css';

function Navbar() {
  return (
    <nav className="navbar">
      <Link to="/">Home</Link>
      <Link to="/profile">Profile</Link>
      <Link to="/game">Game</Link>
      <Link to="/shop">Shop</Link>
    </nav>
  );
}

export default Navbar;
